import React, { useState } from 'react';
import ProductCard from './ProductCard';
import { motion } from 'framer-motion';

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const productData = [
    {
      title: 'EventMate-Ai',
      image: '/assets/EventMateImg_1.jpg', // Update with your actual path
      alt: 'EventMate-Ai Logo ~ Your ultimate AI-Companion for seamless event management!',
      description: 'Smart AI assistant for seamless event RSVP & management with intelligent automation.',
      link: 'https://www.eventmate-ai.com',
    },
    {
      title: 'BusinessAlarm',
      image: '/assets/newLogo.png',
      description: 'From post to profit, We spark your rise. Set it once, let autopilot optimize!',
      link: 'https://autorsvp.masriq.tech',
    },
    {
      title: 'MetaSteel.ai',
      image: '/assets/visionplus.jpg',
      description: 'Intelligent ML visual system for real-time predictions.',
      link: 'https://visionplus.masriq.tech',
    },
    // Add more products here
  ];

  const filteredProducts = productData.filter(product =>
    product.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <motion.section
      id="products"
      className="py-24 px-6 bg-[#0B0C1C] text-white min-h-screen"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h1 className="text-4xl sm:text-5xl font-extrabold text-center mb-10 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent tracking-wide">
        Our Products
      </h1>

      <input
        type="text"
        placeholder="Search products..."
        className="block mx-auto mb-12 px-5 py-3 rounded-full text-black w-full max-w-md shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-400"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        aria-label='Search MASRIQ products'
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9, y: 30 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6, ease: 'easeOut' }}
              viewport={{ once: true }}
            >
              <ProductCard {...product} />
            </motion.div>
          ))
        ) : (
          <p className="text-center col-span-3 text-lg text-white/60">
            No products found.
          </p>
        )}
      </div>
    </motion.section>
  );
};

export default Products;
